<div class="loading" *ngIf="loader"></div>

<div class="row no-gutters content_top_margin bot_spa_aft_sect_heading">
   <div class="col-12">
      <span class="sectionHeading_one">{{'cbconsentpage.pleaseReview' | translate }}</span>
   </div>
</div>
<div class="row no-gutters bot_spa_aft_sect_heading">
   <div class="col-12">
      <span class="sectionHeading_two">{{'cbconsentpage.creditBureauAuthorization' | translate }}
      </span>
   </div>
</div>
<div class="row no-gutters space_between_section">
   <div class="col-12">
      <span>
         <ng-container *ngIf="preQualData.flow_type==prequalType">
            {{'cbconsentpage.consentParagraph' | translate }}
         </ng-container>
         <ng-container *ngIf="preQualData.flow_type==switchType">
            {{'cbconsentpage.digiConsentParagraph' | translate }}
         </ng-container>
         <a [href]="creditCheckLink" target="_blank" data-toggle="tooltip" id="creditLink" data-placement="top"><span
               class="note_link mr-1" aria-labelledby="creditBureauInfo">
               <u>{{
                  'cbconsentpage.moreInfoCreditChecks' |
                  translate}}</u>
            </span>
         </a>
         <p class="m-0"><b>{{'cbconsentpage.noImpactOnCreditScore' | translate }}</b></p>
      </span>
   </div>
</div>
<div class="d-flex  bot_spa_aft_sect_heading">
   <div>
      <label class="checkboxAlignment">
         <ng-container><input id="checkboxinp" data-toggle="modal" [(ngModel)]="cbConsentObj.consent_agreed_1"
               (ngModelChange)="openModal('',content)" type="checkbox"></ng-container>
         <span class="show-for-sr">{{'cbconsentpage.consentCheckBox' | translate
            }}{{applicantName}}{{'cbconsentpage.consentAgree' | translate }}{{'cbconsentpage.openInNew' |
            translate }}</span>
         <span class="outsideChk checkmark"></span>
      </label>
   </div>
   <div class="ml-3">
      <div (click)="setSessionforModal('spanToOpenModal')" id="labelText">
         {{'cbconsentpage.consentCheckBox' | translate
         }}<span><b>{{applicantName}}</b></span>{{'cbconsentpage.consentAgree' | translate }}
         <ul class="pl-4 m-0">
            <li>
               <span>{{'cbconsentpage.consentListOneStart' | translate}}</span>
               <span><button role="button" id="spanToOpenModal12"
                     (click)="openModal(true,content);setSessionforModal('spanToOpenModal')"
                     class="infoButton note_link p-0">
                     <u>{{'cbconsentpage.termstitle' | translate }}</u>
                     <span class="show-for-sr">{{'cbconsentpage.openInNew' | translate }}</span>
                  </button></span>
               <span>{{'cbconsentpage.outerComma' | translate }}</span>
               <span>{{'cbconsentpage.consentListOneEnd' | translate}}</span>
            </li>
            <li><span>{{'cbconsentpage.consentListTwo' | translate}}</span></li>
         </ul>
      </div>
   </div>
</div>
<ng-container *ngIf="preQualData.is_coapplicant_applied==='Y'">
   <div class="d-flex">
      <div>
         <label class="checkboxAlignment">
            <input id="checkboxinp" data-toggle="modal" [(ngModel)]="cbConsentObj.consent_agreed_2"
               (ngModelChange)="openModal('',content)" type="checkbox">
            <span class="show-for-sr">{{'cbconsentpage.consentCheckBox' | translate
               }}{{applicantName2}}{{'cbconsentpage.consentAgree' | translate }}{{'cbconsentpage.openInNew' |
               translate }}</span>
            <span class="checkmark"></span>
         </label>
      </div>
      <div class="ml-3">
         <div (click)="setSessionforModal('spanToOpenModal')" id="labelText">
            {{'cbconsentpage.consentCheckBox' | translate
            }}<span><b>{{applicantName2}}</b></span>{{'cbconsentpage.consentAgree' | translate }}
            <ul class="pl-4 m-0">
               <li>
                  <span>{{'cbconsentpage.consentListOneStart' | translate}}</span>
                  <span><button role="button" id="spanToOpenModal12"
                        (click)="openModal(true,content);setSessionforModal('spanToOpenModal')"
                        class="note_link infoButton">
                        <u>{{'cbconsentpage.termstitle' | translate }}</u>
                        <span class="show-for-sr">{{'cbconsentpage.openInNew' | translate }}</span>
                     </button></span>
                  <span>{{'cbconsentpage.outerComma' | translate }}</span>
                  <span>{{'cbconsentpage.consentListOneEnd' | translate}}</span>
               </li>
               <li><span>{{'cbconsentpage.consentListTwo' | translate}}</span></li>
            </ul>
         </div>
      </div>
   </div>
</ng-container>
<div class="row no-gutters top_height_actionButton content_top_mobile_margin">
   <div class="col-12 d-flex d-md-block flex-column-reverse">
      <cancel-button></cancel-button>
      <button type="button" class="common_btn saveNextBtn_features space_between_button"
         (click)="onContinue('m')">{{'buttonallpages.continuelable' | translate }}</button>
   </div>
</div>

<div class="modal fade" id="cbcnsent" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
   <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
         <div class="modal-header">
            <h2 class="modal-title sectionHeading_one font-weight-bold">
               {{'cbconsentpage.CIBCmortgageprequalificationtitle' | translate }}</h2>

            <button type="button" class="close infoButton" data-dismiss="modal" aria-label="Close" tabindex="0">
               <span class="show-for-sr">{{'cbconsentpage.close' | translate }}</span>

               <span aria-hidden="true" class="text-danger"><i class="fa fa-times"></i></span>
            </button>
         </div>
         <div class="modal-body gfg" tabindex="-1">

            <span class=" pt-3 pl-3" id="subHeading1">{{'cbconsentpage.youmust' | translate }}</span>
            <ul id="subHeading3" class="alignText">
               <li>{{'cbconsentpage.toolUsersMustList1' | translate }}</li>
               <li>{{'cbconsentpage.toolUsersMustList2' | translate }}</li>
               <li>{{'cbconsentpage.toolUsersMustList3' | translate }}</li>
            </ul>

            <ul class="p-2 m-3 alignText" id="subHeading2">
               <li>{{'cbconsentpage.termsAndConditions1' | translate }}</li>
               <li><strong>{{'cbconsentpage.termsAndConditions2' | translate }}</strong></li>
               <li>{{'cbconsentpage.termsAndConditions3' | translate }}</li>
               <li>{{'cbconsentpage.termsAndConditions4' | translate }}</li>
               <li>{{'cbconsentpage.termsAndConditions5' | translate }}</li>
               <li class="mb-0">{{'cbconsentpage.usedforfollowingpurposes' | translate }}</li>
               <ul class="p-0 m-0" id="subHeading4">
                  <li>{{'cbconsentpage.usedforfollowingpurposes1' | translate }}</li>
                  <li class="pb-0 mb-0">{{'cbconsentpage.usedforfollowingpurposes2' | translate }}
                     {{'cbconsentpage.consentLastLine' | translate }}</li>
               </ul>
            </ul>
         </div>
         <div class="modal-footer bg-light ">
            <div
               [ngStyle]="{'border': cbConsentObj.consent_agreed ?  '1px solid #333' :  '1px solid rgb(188, 189, 189)'}"
               class="check-box-er mr-auto" id="modalCheckWrapper">
               <div class="form-check">
                  <label>
                     <!-- (Opens in a dialog) -->
                     <input class="form-check-input zero-opac" [(ngModel)]="cbConsentObj.consent_agreed" type="checkbox"
                        aria-label="I agree to the terms and conditions " id="defaultCheck1">
                     <span class="insideChk checkmark"></span>
                  </label>
                  <label class="form-check-label" for="defaultCheck1">
                     {{'cbconsentpage.iagree' | translate }}
                  </label>
               </div>
            </div>
            <div>
               <button type="button" class="buttonCommon saveNextBtn button-size mr-auto" (click)="onContinue('p')">{{
                  'buttonallpages.continuelable' | translate }}</button>
            </div>
         </div>
      </div>
   </div>
</div>
<!--CR-16 T&C bilingual changes start-->
<ng-template #content let-modal>
   <ng-container *ngIf="!isBilingual">
      <div class="modal-header">
         <h2 *ngIf="preQualData.flow_type==prequalType" class="modal-title sectionHeading_one">
            {{'cbconsentpage.CIBCmortgageprequalificationtitle' | translate }}</h2>
         <h2 *ngIf="preQualData.flow_type==switchType" class="modal-title sectionHeading_one">
            {{'cbconsentpage.CIBCmortgageswitchtitle' | translate }}</h2>
         <button type="button" class="infoButton btn-close closettp" (click)="closeModalCbConcent()" aria-label="Close">
            <span class="show-for-sr">{{'cbconsentpage.close' | translate }}</span>
            <span class=" popUpClose"> &times; </span>
         </button>
      </div>
      <ng-content *ngTemplateOutlet="bilingual;context:{suffix:''}"></ng-content>
      <ng-content *ngTemplateOutlet="tcFooter"></ng-content>
   </ng-container>
   <ng-container *ngIf="isBilingual">
      <div class="row mainPopupDiv">
         <div class="routerContainer mainCol col-md-12">
            <div id="modalHeaderForBL" class="modal-header">
               <h2 class="modal-title sectionHeading_one">
                  <ng-container *ngIf="preQualData.flow_type==prequalType">
                     {{'cbconsentpage.CIBCmortgageprequalificationtitle' | translate }}
                  </ng-container>
                  <ng-container *ngIf="preQualData.flow_type==switchType">
                     {{'cbconsentpage.CIBCmortgageswitchtitle' | translate }}
                  </ng-container>
               </h2>
               <button type="button" class="infoButton btn-close closettp" (click)="closeModalCbConcent()"
                  aria-label="Close">
                  <span class="show-for-sr">{{'cbconsentpage.close' | translate }}</span>
                  <span class="popUpClose"> &times; </span>
               </button>
            </div>
            <div>
               <p class="subHeaderBL p-3">
                  <img alt="helpIcon-icon" aria-hidden="true" role="dialog" src="./assets/icons/helpIcon.svg">
                  {{'cbconsentpage.bilingual.tncInfo' | translate }}
               </p>
            </div>
            <mat-tab-group>
               <mat-tab label="French">
                  <ng-container *ngTemplateOutlet="bilingual;context:{suffix:'_fr'}"></ng-container>
               </mat-tab>
               <mat-tab label="English">
                  <ng-container *ngTemplateOutlet="bilingual;context:{suffix:''}"></ng-container>
               </mat-tab>
            </mat-tab-group>
            <ng-content *ngTemplateOutlet="tcFooter"></ng-content>
         </div>
      </div>
   </ng-container>
</ng-template>


<!-- below is the modal content codebase -->
<ng-template #bilingual let-suffix="suffix">

   <div class="modal-body gfg" tabindex="-1">

      <span id="subHeading1" class="bot_spa_aft_sect_heading">{{'cbconsentpage.youmust'+suffix | translate }}</span>
      <ul id="subHeading3" class="bot_spa_aft_sect_heading alignText">
         <li>{{'cbconsentpage.toolUsersMustList1'+suffix | translate }}</li>
         <li *ngIf="preQualData.flow_type==prequalType">{{'cbconsentpage.toolUsersMustList2'+suffix | translate }}</li>
         <li *ngIf="preQualData.flow_type==switchType">{{'cbconsentpage.toolUsersMustList2Switch'+suffix | translate }}
         </li>
         <li *ngIf="preQualData.flow_type==prequalType">{{'cbconsentpage.toolUsersMustList3'+suffix | translate }}</li>
         <li *ngIf="preQualData.flow_type==switchType">{{'cbconsentpage.digiToolUsersMustList3'+suffix | translate }}
         </li>
      </ul>

      <ul *ngIf="preQualData.flow_type==prequalType" class="digiTermsList bot_spa_aft_sect_heading alignText"
         id="subHeading2">
         <li>{{'cbconsentpage.termsAndConditions1'+suffix | translate }}</li>
         <li><strong>{{'cbconsentpage.termsAndConditions2'+suffix | translate }}</strong></li>
         <li>{{'cbconsentpage.termsAndConditions3'+suffix | translate }}</li>
         <li>{{'cbconsentpage.termsAndConditions4'+suffix | translate }}</li>
         <li>{{'cbconsentpage.termsAndConditions5'+suffix | translate }}</li>
         <li>{{'cbconsentpage.termsAndConditions6'+suffix | translate }}</li>
      </ul>
      <ul id="subHeading3" *ngIf="preQualData.flow_type==prequalType" class="bot_spa_aft_sect_heading alignText">
         <li>{{'cbconsentpage.termsAndConditions6tool1'+suffix | translate }}</li>
         <li>{{'cbconsentpage.termsAndConditions6tool2'+suffix | translate }}</li>
         <li>{{'cbconsentpage.termsAndConditions6tool3'+suffix | translate }}</li>
      </ul>
      <ul *ngIf="preQualData.flow_type==prequalType" class="digiTermsList bot_spa_aft_sect_heading alignText"
         id="subHeading2">
         <li>{{'cbconsentpage.termsAndConditions7'+suffix | translate }}</li>
         <li>{{'cbconsentpage.termsAndConditions8'+suffix | translate }}</li>
      </ul>
      <ul class="bot_spa_aft_sect_heading alignText" id="subHeading3" *ngIf="preQualData.flow_type==prequalType">
         <li>{{'cbconsentpage.termsAndConditions8tool1'+suffix | translate }}</li>
         <li>{{'cbconsentpage.termsAndConditions8tool2'+suffix | translate }}</li>
      </ul>


      <ul *ngIf="preQualData.flow_type==switchType" class="digiTermsList bot_spa_aft_sect_heading alignText"
         id="subHeading2">
         <li>{{'cbconsentpage.digiTermsAndConditions1'+suffix | translate }}</li>
         <li><strong>{{'cbconsentpage.termsAndConditions2'+suffix | translate }}</strong></li>
         <li>{{'cbconsentpage.digiTermsAndConditions3'+suffix | translate }}</li>
         <li>{{'cbconsentpage.digiTermsAndConditions4'+suffix | translate }}</li>
         <li>{{'cbconsentpage.digiTermsAndConditions5'+suffix | translate }}</li>
      </ul>
      <ul id="subHeading3" class="bot_spa_aft_sect_heading alignText" *ngIf="preQualData.flow_type==switchType">
         <li>{{'cbconsentpage.digiTermsAndConditions5tool1'+suffix | translate }}</li>
         <li>{{'cbconsentpage.digiTermsAndConditions5tool2'+suffix | translate }}</li>
         <li>{{'cbconsentpage.digiTermsAndConditions5tool3'+suffix | translate }}</li>
      </ul>
      <ul *ngIf="preQualData.flow_type==switchType" class="digiTermsList bot_spa_aft_sect_heading alignText"
         id="subHeading2">
         <li>{{'cbconsentpage.digiTermsAndConditions6'+suffix | translate }}</li>
         <li>{{'cbconsentpage.digiTermsAndConditions7'+suffix | translate }}</li>
      </ul>
      <ul id="subHeading3" class="bot_spa_aft_sect_heading alignText" *ngIf="preQualData.flow_type==switchType">
         <li>{{'cbconsentpage.digiTermsAndConditions7tool1'+suffix | translate }}</li>
         <li>{{'cbconsentpage.digiTermsAndConditions7tool2'+suffix | translate }}</li>
      </ul>




   </div>

</ng-template>

<!-- below is the modal footer codebase -->
<ng-template #tcFooter>
   <div
      class="modal-footer bg-light d-flex flex-md-row flex-column justify-content-md-between align-items-md-center p-3"
      [ngStyle]="{'display': isBilingual ? 'block' : 'flex'}">
      <div>
         <div class="row no-gutters bot_spa_aft_sect_heading"
            *ngIf="isSubmitted && (preQualData.is_coapplicant_applied=='Y'?(!cbConsentObj.consent_agreed_1||!cbConsentObj.consent_agreed_2):(!cbConsentObj.consent_agreed_1))">
            <div class="col-12">
               <small clas="d-flex align-items-start mt-1">
                  <img src="./assets/images/menu_icons/Alert.svg" alt="">
                <span class="ml-2 errorMsg">{{'cbconsentpage.errorMessage'|translate}}</span>
               </small>
            </div>
         </div>


         <div class="d-flex">
            <div>
               <label class="checkboxAlignment">
                  <input id="checkboxinp" data-toggle="modal" [(ngModel)]="cbConsentObj.consent_agreed_1"
                     type="checkbox">
                  <span class="show-for-sr">{{'cbconsentpage.consentCheckBox' | translate
                     }}{{applicantName}}{{'cbconsentpage.consentAgree' | translate }}
                  </span>

                  <span class="checkmark"
                     [ngClass]="isSubmitted && (!cbConsentObj.consent_agreed_1)?'invalidBorder':''"></span>
               </label>
            </div>
            <div class="ml-3">
               <div (click)="setSessionforModal('spanToOpenModal')" id="labelText">
                  {{'cbconsentpage.consentCheckBox' | translate
                  }}<span><b>{{applicantName}}</b></span>{{'cbconsentpage.consentAgree' | translate }}
                  <!-- below is the "terms and conditions" as button  -->
                  <ul class="pl-4 m-0">
                     <li>
                        <span>{{'cbconsentpage.consentListOneStart' | translate}}</span>
                        <span><button tabindex="-1" role="presentation" id="spanToOpenModal12"
                              class="pointerCls infoButton pl-1">
                              <u>{{'cbconsentpage.termstitle' | translate }}</u>
                           </button></span><span>{{'cbconsentpage.comma'|translate }}</span>
                        <span>{{'cbconsentpage.consentListOneEnd' | translate}}</span>
                     </li>
                     <li><span>{{'cbconsentpage.consentListTwo' | translate}}</span></li>
                  </ul>
               </div>
            </div>
         </div>
         <ng-container *ngIf="preQualData.is_coapplicant_applied==='Y'">
            <div class="d-flex">
               <div>
                  <label class="checkboxAlignment">
                     <input id="checkboxinp" data-toggle="modal" [(ngModel)]="cbConsentObj.consent_agreed_2"
                        type="checkbox">
                     <span class="show-for-sr">{{'cbconsentpage.consentCheckBox' | translate
                        }}{{applicantName2}}{{'cbconsentpage.consentAgree' | translate }}
                     </span>

                     <span class="checkmark"
                        [ngClass]="isSubmitted && (!cbConsentObj.consent_agreed_2)?'invalidBorder':''"></span>
                  </label>
               </div>
               <div class="ml-3">
                  <div (click)="setSessionforModal('spanToOpenModal')" id="labelText">
                     {{'cbconsentpage.consentCheckBox' | translate
                     }}<span><b>{{applicantName2}}</b></span>{{'cbconsentpage.consentAgree' | translate }}
                     <ul class="pl-4 m-0">
                        <li>
                           <span>{{'cbconsentpage.consentListOneStart' | translate}}</span>
                           <span><button tabindex="-1" role="presentation" id="spanToOpenModal12"
                                 class="pointerCls infoButton pl-1">
                                 <u>{{'cbconsentpage.termstitle' | translate }}</u>
                                 <span class="show-for-sr">{{'cbconsentpage.openInNew' | translate }}</span>
                              </button></span><span>{{'cbconsentpage.comma'|translate}}</span>
                           <span>{{'cbconsentpage.consentListOneEnd' | translate}}</span>
                        </li>
                        <li><span>{{'cbconsentpage.consentListTwo' | translate}}</span></li>
                     </ul>
                  </div>
               </div>
            </div>
         </ng-container>
      </div>

      <div class="continueMargin">
         <button type="button" class="common_btn saveNextBtn_features button-size mr-auto" (click)="onContinue('p')">{{
            'buttonallpages.continuelable' | translate }}</button>
      </div>
   </div>
</ng-template>
<!--CR-16 T&C bilingual end-->